import { render } from "./MenuContentItemTableCellInputUpDownBox.vue?vue&type=template&id=6f7bf331"
import script from "./MenuContentItemTableCellInputUpDownBox.vue?vue&type=script&lang=js"
export * from "./MenuContentItemTableCellInputUpDownBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__